<template>
  <div
    class="crafty-avatar"
    data-pendo-ds="avatar"
  >
    <img
      v-if="contact.profile_img && !error"
      alt="Profile Image"
      class="crafty-avatar__img"
      :src="imgSrc"
      @error="setAltImg($event)"
    >
    <span
      v-else
      class="crafty-avatar__initials label-m-medium"
      :style="{ backgroundColor: backgroundColor, color: textColor }"
    >{{ initials }}</span>
  </div>
</template>

<script>
export default {
  name: 'BaseAvatar',
  props: {
    contact: { 
      type: Object, 
      required: true,
      validator: (contact) => {
        return Object.prototype.hasOwnProperty.call(contact, "profile_img")
               || Object.prototype.hasOwnProperty.call(contact, "first_name")
               || Object.prototype.hasOwnProperty.call(contact, "last_name")
      },
    },
    backgroundColor: {
      type: String,
      default: 'var(--pepper-300)',
    },
    textColor: {
      type: String,
      default: 'var(--pepper-1000)',
    },
  },
  data() {
    return {
      error: false,
    }
  },
  computed: {
    imgSrc() {
      return this.contact?.profile_img
    },
    initials() {
      return `${this.firstInitial}${this.lastInitial}`
    },
    firstInitial() {
      return this.contact?.first_name?.at(0) || ''
    },
    lastInitial() {
      return this.contact?.last_name?.at(0) || ''
    },
  },
  methods: {
    setAltImg() {
      this.error = true 
    },
  },
}

</script>

<style scoped lang="scss">

  .crafty-avatar {
    height: 32px;
    width: 32px;
    min-width: 32px;
    border-radius: 50%;
    display: inline-block;
    &__img {
      height: 100%;
      width: 100%;
      border-radius: 50%;
      object-fit: cover;
      object-position: center;
      display: block;
    }
    &__initials {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      border-radius: 50%;
    }
  }

</style>

